export const isValidEmail = (email: string) => {
  if ((email.match(/@/g) || []).length === 1
  && email.split('@')[0] !== ''
  && email.split('@')[1] !== '') {
    return true;
  } return false;
};
